export var ToggleCssClass;
(function (ToggleCssClass) {
    ToggleCssClass["Base"] = "iress-toggle";
    ToggleCssClass["Button"] = "iress-toggle__button";
    ToggleCssClass["Label"] = "iress-toggle__label";
    ToggleCssClass["Layout"] = "iress-toggle--layout";
})(ToggleCssClass || (ToggleCssClass = {}));
export var ToggleLayout;
(function (ToggleLayout) {
    ToggleLayout["Inline"] = "inline";
    ToggleLayout["InlineBetween"] = "inline-between";
    ToggleLayout["InlineReverse"] = "inline-reverse";
    ToggleLayout["Stack"] = "stack";
})(ToggleLayout || (ToggleLayout = {}));
//# sourceMappingURL=toggle.types.js.map